import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import blogService from "../../services/blogService";

const SidebarBlog = ({ setSearchQuery }) => {
  const [relatedBlogs, setRelatedBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRelatedBlogs = async () => {
      try {
        setLoading(true);
        const data = await blogService.getAllBlogs();
        // Get the 3 most recent blogs for the related posts section
        const sortedBlogs = data
          .sort((a, b) => new Date(b.CreatedDate) - new Date(a.CreatedDate))
          .slice(0, 3);
        setRelatedBlogs(sortedBlogs);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching related blogs:", err);
        setLoading(false);
      }
    };
    fetchRelatedBlogs();
  }, []);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <div className="col-xl-4 col-lg-4 theiaStickySidebar">
      {/* Search Bar */}
      <div className="card mb-3">
        <div className="card-header border-0 pb-0">
          <div className="pb-3 border-bottom">
            <h5>
              <i className="isax isax-search-normal-1 text-primary fs-16 me-2"></i>
              Search
            </h5>
          </div>
        </div>
        <div className="card-body pt-3">
          <div className="bg-light-100 p-3 rounded border">
            <div className="input-icon">
              <span className="input-icon-addon">
                <i className="isax isax-search-normal-1 fs-14"></i>
              </span>
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                onChange={handleSearch}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Related Posts */}
      <div className="card mb-3">
        <div className="card-header border-0 pb-0">
          <div className="pb-3 border-bottom">
            <h5>
              <i className="ti ti-brand-blogger text-primary fs-16 me-2"></i>
              Related Posts
            </h5>
          </div>
        </div>
        <div className="card-body pt-3">
          {loading ? (
            <div className="text-center">Loading...</div>
          ) : relatedBlogs.length === 0 ? (
            <div className="text-center">No related posts found.</div>
          ) : (
            relatedBlogs.map((blog) => (
              <div className="blog-post mb-3" key={blog.id}>
                <div className="d-flex align-items-center">
                  <Link
                    to={`/blog-detail/${blog.id}`}
                    className="avatar avatar-xxl flex-shrink-0 me-2"
                  >
                    <img
                      src={blog.imageUrls[0] || ""}
                      className="rounded"
                      alt={blog.name || "Blog Image"}
                    />
                  </Link>
                  <div>
                    <Link
                      to={`/blog-detail/${blog.id}`}
                      className="two-line-ellipsis fs-14 fw-medium me-2"
                    >
                      {
                        <div
                          dangerouslySetInnerHTML={{
                            __html: blog.name || "No description available.",
                          }}
                        />
                      }
                    </Link>
                    <div className="d-flex align-items-center mt-2">
                      <Link to="" className="d-flex align-items-center pe-2 ">
                        <span className="avatar avatar-xs ">
                          <img
                            src={blog.userImage || ""}
                            className="blog-user-img rounded-circle border border-light"
                            alt={blog.authorName || "User"}
                          />
                        </span>
                        <p className="fs-14 text-truncate">
                          {blog.authorName || "User"}
                        </p>
                      </Link>
                    </div>
                    <p className="fs-14 text-truncate me-1 mt-1">
                      <i className="isax isax-calendar-2 me-2"></i>
                      {new Date(blog.createdDate).toLocaleDateString()}
                    </p>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default SidebarBlog;
